export const idTipologiaStanzaToKeyI18n = {
/*1:ufficio, 2:sala riunioni, 3:mensa, 4:parcheggio */

    1:{titleDataTable:"titleDataTable_office", prefixRowDataTable:"prefixDataTable_office"},
    2:{titleDataTable:"titleDataTable_Meeting_room",prefixRowDataTable:"prefixRowDataTable_Meeting_room"},
    3:{titleDataTable:"titleDataTable_Carpark", prefixRowDataTable:"prefixRowDataTable_parking_spot"},
    4:{titleDataTable:"titleDataTable_Cafeteria", prefixRowDataTable:"prefixRowDataTable_cafeteria_seating"}
}